import React from 'react';
import { css } from '@linaria/core';
import { brand, findColorFromCSSVariable, theme } from '@terveystalo/design-system-theme';
import { Icon, Text } from '../../atoms';
import { classnames } from '../../utils';
const commonStyles = css `
  display: flex;
  align-items: flex-start;
  padding: ${theme.spacing['1']};
`;
const success = css `
  background-color: ${brand.alert.color.success.background};
  border: ${theme.border.width.xxs} solid ${brand.alert.color.success.border};
`;
const info = css `
  background-color: ${brand.alert.color.info.background};
  border: ${theme.border.width.xxs} solid ${brand.alert.color.info.border};
`;
const error = css `
  background-color: ${brand.alert.color.error.background};
  border: ${theme.border.width.xxs} solid ${brand.alert.color.error.border};
`;
const warning = css `
  background-color: ${brand.alert.color.warning.background};
  border: ${theme.border.width.xxs} solid ${brand.alert.color.warning.border};
`;
/**
 * Alert component for displaying simple messages with an optional icon.
 */
export const Alert = ({ variant = 'info', icon, className, childAs = 'span', childClassName, children, style, ...rest }) => {
    const styles = determineStyles(variant);
    return (React.createElement("div", { className: classnames(commonStyles, styles.className, 'items-baseline', className), ...rest },
        icon && (React.createElement(Icon, { name: icon, color: styles.color, className: css `
            margin-right: ${theme.spacing[1]};
          ` })),
        React.createElement(Text, { size: "m", as: childAs, color: styles.color, className: childClassName }, children)));
};
const determineStyles = (variant = 'info') => {
    const color = findColorFromCSSVariable(brand.alert.color[variant].content);
    switch (variant) {
        case 'success':
            return { className: success, color };
        case 'warning':
            return { className: warning, color };
        case 'error':
            return { className: error, color };
        case 'info':
            return { className: info, color };
        default:
            const _exhaustiveCheck = variant;
            return _exhaustiveCheck;
    }
};


import "../../../css/molecules/Alert/Alert.css";
